

import React, { useState } from "react";
import { View, ScrollView, SafeAreaView, StyleSheet, Picker, Text, TouchableOpacity, Image } from "react-native";
import { TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from 'react-i18next';
import { i18n } from './../../../assets/lang/i18next';
const useStyles = makeStyles(() => ({
    textField: {
        width: "100%",
        marginTop: 20,
        marginLeft: "auto",
        marginRight: "auto",
        paddingBottom: 0,
        marginTop: 0,
        fontWeight: 500,
        fontSize: 13,
        direction: "rtl",
        "& .MuiFormLabel-root": {
            color: "black",
            textAlign: 'right',
            fontFamily: 'IranSans',
            fontSize: 13, direction: 'rtl', width: '100%',
        },
        "& .MuiInputLabel-asterisk": {
            color: '#d12023',
            fontWeight: 900,
        },
        "& .MuiInputBase-input": {
            color: '#333', textAlign: 'center'
        },
        '& label.Mui-focused': {
            color: '#333',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'yellow',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: 'white',
            },
            '&:hover fieldset': {
                borderColor: 'blue',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#333',
            },
        },

    },
    labelRoot: {
        right: 20,
    },
    shrink: {
        transformOrigin: "top right",
    },
    input: {
        color: "black", fontFamily: 'IranSans',
        fontSize: 13,

    },
    btn_calculate: {
        color: '#333',
        backgroundColor: 'gray',
        fontFamily: 'IranSans',
        fontSize: 13, fontWeight: 900,
    }
}));
const EvapratorChandMedareh = (props) => {
    const { t, i18n } = useTranslation();
    const classes = useStyles();
    const [MSGSardkganeSelected, setMSGSardkganeSelected] = useState('');
    const [isshowkarbari, setIsshowkarbari] = useState(false);
    const [answermulti, setanswermulti] = useState("");
    const [comprosor, setcomprosor] = useState("S6H-20.2");
    const [tedad, settedad] = useState(2);
    const [ansevap, setansevap] = useState("");
    return (
        <ScrollView>
            <SafeAreaView style={styles.container}>

                <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'space-between', width: '90%' }}>

                    <TouchableOpacity style={{ marginTop: 15, flex: 1, flexDirection: 'row' }} onPress={() => props.navigation.navigate('CompEvaprator')}>
                        <Image resizeMode="contain" source={require('../../../assets/icons/comparisonicon.png')} style={{ width: 35, height: 35 }} />
                        <Text style={{ fontSize: 12, marginTop: 7, fontFamily: 'IranSans', color: 'blue' }}>{t('ComparisonEvaprator')}</Text>
                    </TouchableOpacity>
                    <Text style={{ fontFamily: 'IranSans', fontWeight: 900, fontSize: 14, marginTop: 15, marginBottom: 10 }}>{t('multiCircuitsEvaporatorsselection')}</Text>

                </View>

                <View style={styles.form}>
                    <Text style={styles.titleform}>{t('selectyourrefrigerant')}</Text>
                    <Picker
                        mode="dropdown"
                        style={styles.dropdown}
                    >
                        <Picker.Item label="R22" value="R22" />
                        <Picker.Item label="R404/R507a" value="R404/R507a" />

                    </Picker>
                    <Text style={styles.titleform}>{t('evapratorusage')}</Text>
                    <Picker
                        mode="dropdown"
                        style={styles.dropdown}
                        onValueChange={(itemValue, itemIndex) => {
                            switch (itemValue) {
                                case '1':
                                    setMSGSardkganeSelected(() => {
                                        setIsshowkarbari(true);
                                        return (
                                            <View>
                                                <Text></Text>
                                            </View>
                                        )
                                    });
                                    break;

                                case '2':
                                    setMSGSardkganeSelected(() => {
                                        setIsshowkarbari(true);
                                        return (
                                            <View>
                                                <Text></Text>
                                            </View>
                                        )
                                    });
                                    break;

                                case '3':
                                    setMSGSardkganeSelected(() => {
                                        setIsshowkarbari(true);
                                        return (
                                            <View>
                                                <Text></Text>
                                            </View>
                                        )
                                    });
                                    break;

                                case '4':
                                    setMSGSardkganeSelected(() => {
                                        setIsshowkarbari(true);
                                        return (
                                            <View>
                                                <Text></Text>

                                            </View>
                                        )
                                    });
                                    break;
                                case '5':
                                    setMSGSardkganeSelected(() => {
                                        setIsshowkarbari(true);
                                        return (
                                            <View>
                                                <Text></Text>

                                            </View>
                                        )
                                    });
                                    break;
                                case '6':
                                    setMSGSardkganeSelected(() => {
                                        setIsshowkarbari(true);
                                        return (
                                            <View>
                                                <Text></Text>

                                            </View>
                                        )
                                    });
                                    break;
                                default:
                                    setIsshowkarbari(true);

                            }


                        }}
                    >
                        <Picker.Item label={t('blastfreezer')} value="6" />
                    </Picker>

                    <Text style={{ padding: 7, color: '#06619b', fontSize: 12, fontFamily: 'IranSans', backgroundColor: '#d6d6d6', marginLeft: '10%', marginRight: '10%', borderRadius: 6, marginBottom: 7 }}>
                        <View>
                            <Text>{t('Quickfreezingofproducts')}</Text>
                            <Text>{t('Thetemperatureofthecoldroomis40degreesCelsius')}</Text>
                            <Text>{t('temperaturedifferenceisequalto5degreesCelsius')}</Text>
                        </View>

                    </Text>



                    <Text style={styles.titleform}>{t('compressortype')}</Text>
                    <Picker
                        mode="dropdown"
                        style={styles.dropdown}
                    >
                        <Picker.Item label={t('Bitzer')} value="0" />


                    </Picker>

                    <Text style={styles.titleform}>{t('Compressormodel')}</Text>
                    <Picker
                        mode="dropdown"
                        style={styles.dropdown}
                        onValueChange={(itemValue, itemIndex) => {
                            setcomprosor(itemValue);
                        }}
                    >
                        <Picker.Item label="S6H-20.2" value="S6H-20.2" />
                        <Picker.Item label="S6G-25.2" value="S6G-25.2" />
                        <Picker.Item label="S6F-30.2" value="S6F-30.2" />
                    </Picker>
                    <Text style={styles.titleform}>{t('Noofcompressors')}</Text>
                    <Picker
                        mode="dropdown"
                        style={styles.dropdown}
                        onValueChange={(itemValue, itemIndex) => {
                            settedad(itemValue);
                        }}
                    >
                        {
                            comprosor == "S6H-20.2" || comprosor == "S6G-25.2" ?
                                <>
                                    <Picker.Item label="2" value="2" />
                                    <Picker.Item label="3" value="3" />
                                </>
                                :
                                <>
                                    <Picker.Item label="2" value="2" />
                                    <Picker.Item label="3" value="3" />
                                    <Picker.Item label="4" value="4" />
                                    <Picker.Item label="5" value="5" />
                                </>

                        }


                    </Picker>

                    <TouchableOpacity onPress={() => {
                        setanswermulti(t('PleasecontactArshekarcompanytogetproductspecifications'));
                        if (comprosor == "S6H-20.2") {
                            if (tedad == 2)
                                setansevap("HTC-2C2-363");
                            else
                                if (tedad == 3)
                                    setansevap("HTC-3C2-363");
                                else {
                                    setansevap("");
                                    setanswermulti("");
                                }

                        }
                        if (comprosor == "S6G-25.2") {
                            if (tedad == 2)
                                setansevap("HTC-2D2-363");
                            else
                                if (tedad == 3)
                                    setansevap("HTC-3D2-463");
                                else {
                                    setansevap("");
                                    setanswermulti("");
                                }
                        }
                        if (comprosor == "S6F-30.2") {
                            if (tedad == 2)
                                setansevap("HTC-2E2-463");
                            else
                                if (tedad == 3)
                                    setansevap("HTC-3E2-563");
                                else
                                    if (tedad == 4)
                                        setansevap("HTC-4E2-863");
                                    else
                                        if (tedad == 5)
                                            setansevap("HTC-5E2-1063");
                                        else {
                                            setansevap("");
                                            setanswermulti("");
                                        }
                        }


                    }} style={{ backgroundColor: '#022a4c', color: 'white', padding: 15, margin: 15, borderRadius: 4 }}>
                        <Text style={styles.titlebutton}>
                            {t('Computing')}
                        </Text>
                    </TouchableOpacity>
                    {
                        (ansevap != "") ?
                            <View>
                                <Text style={styles.titleform}>{t('suggestedEvaporators')}</Text>
                                <Text></Text>
                                <Text style={{ fontFamily: 'IranSans', fontSize: 14, fontWeight: 900, color: 'green', textAlign: 'center' }}>{ansevap}</Text>

                            </View>
                            :
                            null
                    }
                    {
                        (answermulti != "") ?
                            <View>
                                <Text style={styles.titleform}></Text>
                                <Text style={{ fontFamily: 'IranSans', fontSize: 14, fontWeight: 900, color: '#d12023', textAlign: 'center' }}>
                                    {answermulti}
                                </Text>
                            </View>
                            :
                            null
                    }




                </View>
            </SafeAreaView>
        </ScrollView>
    )
}

export default EvapratorChandMedareh;

const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        backgroundColor: '#ebecec',

    }
    ,
    titleform: {
        marginBottom: 10,
        marginTop: 10,
        fontFamily: 'IranSans',
        fontSize: 13,
    }
    ,
    inputtext: {
        backgroundColor: '#fff',
        textAlign: 'center',
        borderColor: "gray",
        width: "100%",
        borderWidth: 1,
        borderRadius: 10,
        padding: 10, width: '100%', height: 30
    }
    ,
    dropdown: {
        height: 50,
        width: '100%',
        marginBottom: 10,
        fontFamily: 'IranSans',
        fontSize: 13,
        borderWidth: 0,
        textAlign: 'center',
        backgroundColor: '#c9c9c9',
        direction: 'rtl',



    },
    form: {
        width: '90%',
        backgroundColor: '#ddd',
        margin: 10,
        padding: 10,
        justifyContent: 'center',
        alignItems: 'stretch',
        shadowColor: '#000',
        shadowOffset: { width: 1, height: 0.5 },
        shadowOpacity: 0.7,
        shadowRadius: 3,
    }
    ,
    touchable: {
        alignItems: 'center',
        justifyContent: 'center',
        paddingVertical: 12,
        paddingHorizontal: 32,
        borderRadius: 4,
        elevation: 3,
        backgroundColor: 'blue',
        marginBottom: 15,
        margin: 15,
    },
    titlebutton: {

        fontSize: 14,
        textAlign: 'center',
        lineHeight: 21,
        fontWeight: 'bold',
        fontFamily: 'IranSans',
        letterSpacing: 0.25,
        color: 'white',

    },
    spinner: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: 'rgba(50,70,110,0.3)',
        bottom: 0,
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9000,
    }

});
